import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useContextApi } from '../context/ContextApi'; // Sesuaikan dengan lokasi file ContextApi Anda

const AuthMiddleware = ({ children, page }) => {
    const { logged } = useContextApi();
    const navigate = useNavigate();
  
    useEffect(() => {
        if (page == 'admin' && !logged) {
          navigate('/LoginAdmin');
        }
        if (page == 'pelanggan' && !logged) {
          navigate('/');
        }
    }, []);
    
    return children; // Tidak perlu mengembalikan Route lagi
  };
  

export default AuthMiddleware;
